import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import ReactDatePicker from "react-datepicker";
import Tooltip from "react-bootstrap/Tooltip";
import RatingComponent from "../../../../components/RatingComponent";
import RatingComponentWithoutNA from "../../../../components/RatingComponentWithoutNA";
import Editor from "../../../../components/editor";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import axios from "axios";
import validate from "./validate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileUploader } from "../../../../components/MultipleFileUploader";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import CustomDatePicker from "../../../../components/Custom-Datepicker-Type";
import CustomDatePickerIndex from "../../../../components/Custom-Datepicker-Type-Index-Module";
import { FaSpinner } from "react-icons/fa";
import Accordion from "react-bootstrap/Accordion";
import CustomPhoneInput from "../../../../components/phone-input";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { BsHandbag } from "react-icons/bs";
import ProfileInput from "../../../../components/ProfilePic";
import { subYears, toDate } from "date-fns";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const AddEmployee = () => {
  const navigate = useNavigate();
  const { candidate_line_up_id } = useParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);

  const [formData, setFormData] = useState({});

  const [formDataVerified, setFormDataVerifed] = useState({
    candidate_line_up_id: candidate_line_up_id,
    Details: 0,
    Contact: 0,
    Qualification: [],
    Identities: [],
    Files: [],
    employment_history: [],
  });
  console.log('formDataVerified', formDataVerified);
  
  const [bankOptions, setBankOptions] = useState([]);
  const [maritialStatusOptions, setMaritialStatusOptions] = useState([]);

  /* Setting data for components*/
  const [activeKey, setActiveKey] = useState("1");

  /* Setting data for components end*/
  /*Handling Accordion Toggle Start*/
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  /*Handling Accordion Toggle End*/
  useEffect(() => {
    fetchDetails();
  }, []);
  const fetchDetails = async () => {
    let response = await PostServiceCaller(
      API_URL + "fetch-candidate-line-up-details",
      { candidate_line_up_id: candidate_line_up_id },
      "post"
    );
    if (response?.data?.status == "success") {
      console.log(`responese from API`);
      console.log(response.data.data);
      setFormData({
        ...formData,
        Title: response?.data?.data?.Title?.label,
        FirstName: response?.data?.data?.FirstName,
        MiddleName: response?.data?.data?.MiddleName,
        LastName: response?.data?.data?.LastName,
        DateOfBirth: moment(response?.data?.data?.DateOfBirth).format(
          "DD-MMM-YYYY"
        ),
        PersonalEmail: response?.data?.data?.candidate_details?.EmailID,
        FatherName: response?.data?.data?.FatherName,
        FatherDOB: response?.data?.data?.FatherDOB,
        MotherName: response?.data?.data?.MotherName,
        MotherDOB: response?.data?.data?.MotherDOB,
        Gender: response?.data?.data?.Gender,
        ProfilePic: response?.data?.data?.ProfilePic,
        ProfilePicUrl: response?.data?.data?.ProfilePicUrl,
        MobileNo1: response.data.data.MobileNo1
          ? response.data.data?.MobileNo1
          : "",
        MobileNo2: response.data.data.MobileNo2
          ? response.data.data?.MobileNo2
          : "",
        EmergencyPhoneNo: response?.data?.data?.EmergencyPhoneNo,
        EmergencyContactName: response?.data?.data?.EmergencyContactName,
        EmergencyContactRelation: response?.data?.data?.EmergencyContactRelation,
        PersonalEmail: response?.data?.data?.PersonalEmail,
        CorrespondenceAddress: response?.data?.data?.CorrespondenceAddress,
        CorrespondenceCity: response?.data?.data?.CorrespondenceCity,
        CorrespondenceState: response?.data?.data?.CorrespondenceState,
        CorrespondenceCountry: response?.data?.data?.CorrespondenceCountry,
        CorrespondenceZip: response?.data?.data?.CorrespondenceZip,
        CorrespondenceAddressPrint:
          response?.data?.data?.CorrespondenceAddressPrint,
        IsCopyAddress: response?.data?.data?.IsCopyAddress,
        PermanentAddress: response?.data?.data?.PermanentAddress,
        PermanentCity: response?.data?.data?.PermanentCity,
        PermanentState: response?.data?.data?.PermanentState,
        PermanentCountry: response?.data?.data?.PermanentCountry,
        PermanentZip: response?.data?.data?.PermanentZip,
        PermanentAddressPrint: response?.data?.data?.PermanentAddressPrint,
        Qualification: response?.data?.data?.Qualification,
        employeeAttachments: response?.data?.data?.employeeAttachments,
        employment_history: response?.data?.data?.employment_history || [],
        Identities: response?.data?.data?.Identities,
        Active: response?.data?.data?.Active,
        CorrepondenceAddressType: response?.data?.data?.CorrepondenceAddressType,
        PermanentAddressType: response?.data?.data?.PermanentAddressType,
        employeebank: response?.data?.data?.employeebank || [],
        TotalYearExp: response?.data?.data?.TotalYearExp || "",
        TotalMonthExp: response?.data?.data?.TotalMonthExp || "",
        MaritalStatusName: response?.data?.data?.MaritalStatusName || "",
        MaritalStatus_021: response?.data?.data?.MaritalStatus_021 
                          ? parseInt(response.data.data.MaritalStatus_021) 
                          : "",
        SpouseName: response?.data?.data?.SpouseName || "",
        SpouseDOB: response?.data?.data?.SpouseDOB || "",
        Child1Name: response?.data?.data?.Child1Name || "",
        Child1DOB: response?.data?.data?.Child1DOB || "",
        Child2Name: response?.data?.data?.Child2Name || "",
        Child2DOB: response?.data?.data?.Child2DOB || "",
        BloodGroupName: response?.data?.data?.BloodGroupName || "",
        PFNomineeName: response?.data?.data?.PFNomineeName || "",
        PFNomineeRelation: response?.data?.data?.PFNomineeRelation || "",
      });

      // Also set bank options and marital status options from API response
      setBankOptions(response?.data?.data?.banks || []);
      
      setMaritialStatusOptions(response?.data?.data?.maritial_status || []);

      setPageLoading(false);
      let identities = [];

      for (let i = 0; i < response.data.data.Identities.length; i++) {
        identities.push(0);
      }
      let Qualification = [];
      for (let i = 0; i < response.data.data.Qualification.length; i++) {
        Qualification.push(0);
      }
      let files = [];
      for (let i = 0; i < response.data.data?.files?.length; i++) {
        files.push(0);
      }
      let employment_history = [];
      if (response.data.data.employment_history) {
        for (let i = 0; i < response.data.data.employment_history.length; i++) {
          employment_history.push(0);
        }
      }
      setFormDataVerifed({
        ...formDataVerified,
        Qualification: response?.data?.verified_data?.Qualification,
        Files: response?.data?.verified_data?.Files,
        Identities: response?.data?.verified_data?.Identities,
        Contact: response?.data?.verified_data?.Contact,
        Details: response?.data?.verified_data?.Details,
        employment_history: response?.data?.verified_data?.employment_history || employment_history,
      });
      // console.log('after setting form data verified', formDataVerified);
      // console.log(formDataVerified);
    } else {
      navigate("/link-expired");
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Verify Candidate Details"));
  }, []);

  /* Handle Submit Start*/
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formDataVerified);
    let isCompletelyVerified = checkVerificationDetails(formDataVerified);
    if (!isCompletelyVerified.status) {
      setSubmit(true);
      let response = await PostServiceCaller(
        API_URL + "verify-candidate-details",
        formDataVerified,
        "post"
      );
      toast.success(response.data.message);
      setSubmit(false);
      navigate("/candidate-in-process");
    } else {
      let message = "";
      console.log(`is completely verfied after validation`);
      console.log(isCompletelyVerified);
      switch (isCompletelyVerified.tab) {
        case 1:
          message = "General Details";
          break;
        case 2:
          message = "Contact Details";
          break;
        case 3:
          message = "Qualification Details";
          break;
        case 4:
          message = "Employee Attachments";
          break;
        case 5:
          message = "Employee Identities";
          break;
      }
      setActiveKey(isCompletelyVerified.tab.toString());
      toast.error(`Please verify ${message}`);
    }
  };
  const checkVerificationDetails = (verifiedData) => {
    console.log(`verified data is here`);
    console.log(verifiedData);
    let defaultStatus = { status: false, tab: 0 };
    if (verifiedData?.Contact == 0) {
      return { status: true, tab: 2 };
    }
    if (verifiedData?.Details == 0) {
      return { status: true, tab: 1 };
    }
    for (let row of verifiedData?.Qualification) {
      if (row == 0) {
        return { status: true, tab: 3 };
      }
    }
    for (let row of verifiedData?.Files) {
      if (row == 0) {
        return { status: true, tab: 4 };
      }
    }
    for (let row of verifiedData?.Identities) {
      if (row == 0) {
        return { status: true, tab: 5 };
      }
    }
    return defaultStatus;
  };
  /* Handle Submit End*/
  const handleChange = (e, type, index, accept = false) => {
    e.preventDefault();
    switch (type) {
      case "Identities":
        let identities = formDataVerified.Identities;
        identities[index] = accept ? 1 : 3;
        setFormDataVerifed({
          ...formDataVerified,
          Identities: identities,
        });
        break;
      case "Files":
        let files = formDataVerified.Files;
        files[index] = accept ? 1 : 3;
        setFormDataVerifed({
          ...formDataVerified,
          Files: files,
        });
        break;
      case "Qualification":
        let Qualification = formDataVerified.Qualification;
        Qualification[index] = accept ? 1 : 3;
        setFormDataVerifed({
          ...formDataVerified,
          Qualification: Qualification,
        });
        break;
      case "employment_history":
        let employment_history = formDataVerified.employment_history;
        employment_history[index] = accept ? 1 : 3;
        setFormDataVerifed({
          ...formDataVerified,
          employment_history: employment_history,
        });
        break;
      case "Details":
        setFormDataVerifed({
          ...formDataVerified,
          Details: accept ? 1 : 3,
        });
        break;
      case "Additional":
        setFormDataVerifed({
          ...formDataVerified,
          Additional: accept ? 1 : 3,
        });
        break;
      case "BankDetails":
      let bankDetails = [...(formDataVerified.BankDetails || [])];
      bankDetails[index] = accept ? 1 : 3;
      setFormDataVerifed({
        ...formDataVerified,
        BankDetails: bankDetails,
      });
      break;
      case "Contact":
        setFormDataVerifed({
          ...formDataVerified,
          Contact: accept ? 1 : 3,
        });
        break;
    }
    console.log(`form data verified`);
    console.log(formDataVerified);
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <form id="formOne" className="rounded mt-2 bg-white">
            <div className="container-fluid p-0">
              {/* tab section start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="general-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#general"
                    type="button"
                    role="tab"
                    aria-controls="general"
                    aria-selected="true"
                  >
                    General Details
                    <span className="text-danger">
                      {formData.job_title?.label.trim() &&
                        `: ${formData.job_title.label}`}
                    </span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="Contact-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Contact"
                    type="button"
                    role="tab"
                    aria-controls="Contact"
                    aria-selected="false"
                  >
                    Contact Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="Qualification-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Qualification"
                    type="button"
                    role="tab"
                    aria-controls="Qualification"
                    aria-selected="false"
                  >
                    Qualification
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="employment-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#employment"
                    type="button"
                    role="tab"
                    aria-controls="employment"
                    aria-selected="false"
                  >
                    Employment Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="Bank-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Bank"
                    type="button"
                    role="tab"
                    aria-controls="Bank"
                    aria-selected="false"
                  >
                    Bank Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="attachment-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#attachment"
                    type="button"
                    role="tab"
                    aria-controls="attachment"
                    aria-selected="false"
                  >
                    Attachments
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="identities-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#identities"
                    type="button"
                    role="tab"
                    aria-controls="identities"
                    aria-selected="false"
                  >
                    Identities
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="additional-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#additional"
                    type="button"
                    role="tab"
                    aria-controls="additional"
                    aria-selected="false"
                  >
                    Additional Details
                  </button>
                </li>
              </ul>

              {/* Tab Body Section start */}
              <div className="tab-content p-2" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="general"
                  role="tabpanel"
                  aria-labelledby="general-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-10">
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="">
                              <label className="form-label">
                                Title <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                name="FirstName"
                                value={formData.Title}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label htmlFor="FirstName" className="form-label">
                                First Name
                                <span className="required">*</span>
                              </label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="FirstName"
                                value={formData.FirstName}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                htmlFor="MiddleName"
                                className="form-label"
                              >
                                Middle Name
                              </label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="MiddleName"
                                value={formData.MiddleName}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label htmlFor="LastName" className="form-label">
                                Last Name
                                <span className="required">*</span>
                              </label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="LastName"
                                value={formData.LastName}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                htmlFor="FatherName"
                                className="form-label"
                              >
                                Father Name
                              </label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="FatherName"
                                value={formData.FatherName}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                htmlFor="MotherName"
                                className="form-label"
                              >
                                Mother Name
                              </label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="MotherName"
                                value={formData.MotherName}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="">
                              <label className="form-label">
                                Gender <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                name="Gender"
                                value={formData.Gender?.label}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <label className="form-label">
                              Date Of Birth<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              disabled={true}
                              className="form-control"
                              name="Gender"
                              value={formData.DateOfBirth}
                            ></input>
                          </div>
                          {/* <div className="col-sm-2">
                            <label htmlFor="IsInActive" className="form-label">
                              Active
                            </label>
                            <div className="me-2 mt-0">
                              <div className="d-flex">
                                <div className="form-check me-2" key={"Yes"}>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`rating_2`}
                                    value={"Yes"}
                                    checked={
                                      formData.Active == 0 ? "checked" : false
                                    }
                                    disabled={true}
                                  />
                                  <label className="form-check-label">
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check me-2" key={"No"}>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`rating_2`}
                                    value={"No"}
                                    checked={
                                      formData.Active == 1 ? "checked" : false
                                    }
                                    disabled={true}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`rating_1_No`}
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <div className="col-sm-2  mt-4">
                        <img
                          alt="User Pic"
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src =
                              "https://via.placeholder.com/150";
                          }}
                          src={formData.ProfilePicUrl}
                          id="profile-image1"
                          width="150"
                          height="150"
                        />
                        <div className="row">
                          {/* <div className="col-sm-12">
                                                            <div class="form-check mt-2">
                                                                <input class="form-check-input"

                                                                    type="checkbox"
                                                                    name="Details"
                                                                    value="1"
                                                                    id="Details"
                                                                    checked={formDataVerified.Details == 1 ? 'checked' : false}
                                                                    onClick={(e) => handleChange(e, 'Details', 0)}
                                                                />
                                                                <label class="form-check-label" for="IsCopyAddress">
                                                                    Is Verified?
                                                                </label>
                                                            </div>
                                                        </div> */}
                          <div className="col-sm-12 text-end">
                            {(formDataVerified.Details == 0 ||
                              formDataVerified.Details == 2) && (
                                <div className="d-flex justify-content-end">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-bottom">
                                        Accept
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      onClick={(e) =>
                                        handleChange(e, "Details", 0, true)
                                      }
                                      className="btn btn-sm btn-success me-1"
                                    >
                                      <i className="bi bi-check2-circle"></i>
                                    </button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-bottom">
                                        Reject
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      onClick={(e) =>
                                        handleChange(e, "Details", 0, false)
                                      }
                                      className="btn btn-sm btn-danger"
                                    >
                                      <i className="bi bi-x-circle"></i>
                                    </button>
                                  </OverlayTrigger>
                                </div>
                              )}
                            {formDataVerified.Details == 1 && (
                              <>
                                <span className="text-success">ACCEPTED</span>
                              </>
                            )}
                            {formDataVerified.Details == 3 && (
                              <>
                                <span className="text-danger">REJECTED</span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* contact details */}
                <div
                  className="tab-pane fade show"
                  id="Contact"
                  role="tabpanel"
                  aria-labelledby="Contact-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                            Contact No<span className="required">*</span>
                          </label>
                          <input
                            disabled={true}
                            // defaultCountry="in"
                            // prefix=""
                            // className="input.react-international-phone-input"
                            className="form-control"
                            value={formData.MobileNo1}
                            disableFormatting={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">Whatapp No.</label>
                          <input
                            disabled={true}
                            // defaultCountry="in"
                            // prefix=""
                            // className="input.react-international-phone-input"
                            value={formData.MobileNo2}
                            className="form-control"
                            disableFormatting={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">Emerg. Phone No.</label>
                          <input className="form-control"
                            disabled={true}
                            // defaultCountry="in"
                            // prefix=""
                            // className="input.react-international-phone-input"
                            value={formData.EmergencyPhoneNo}
                            disableFormatting={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                            Emerg. Contact Name<span className="required">*</span>
                          </label>
                          <input
                            disabled={true}
                            className="form-control"
                            type="text"
                            name="EmergencyContactName"
                            value={formData.EmergencyContactName}
                          />
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">Contact Relation<span className="required">*</span></label>
                          <input
                            disabled={true}
                            className="form-control"
                            type="text"
                            name="EmergencyContactRelation"
                            value={formData.EmergencyContactRelation}
                          />
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">Personal Email<span className="required">*</span></label>
                          <input
                            disabled={true}
                            className="form-control"
                            type="text"
                            name="PersonalEmail"
                            value={formData.PersonalEmail}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <p>
                          <strong>Correspondence Address</strong>
                        </p>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="">
                              <label className="form-label">Address Type</label>
                              <Select
                                isDisabled={true}
                                name="CorrepondenceAddressType"
                                value={formData.CorrepondenceAddressType}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                Address <span className="required">*</span>
                              </label>
                              <input
                                className="form-control"
                                disabled={true}
                                type="text"
                                name="CorrespondenceAddress"
                                value={formData.CorrespondenceAddress}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Country</label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="CorrespondenceCountry"
                                value={formData.CorrespondenceCountry?.label}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">State</label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="CorrespondenceState"
                                value={formData.CorrespondenceState?.label}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <label className="form-label">
                              City<span className="required">*</span>
                            </label>
                            <Select
                              isDisabled={true}
                              name="CorrespondenceCity"
                              value={formData.CorrespondenceCity}
                            ></Select>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Zip Code</label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="CorrespondenceZip"
                                value={formData.CorrespondenceZip}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label className="form-label">
                                Print Address
                              </label>
                              <input
                                disabled={true}
                                className="form-control"
                                type="text"
                                name="CorrespondenceAddressPrint"
                                value={formData.CorrespondenceAddressPrint}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <p>
                          <strong>Permanent Address</strong>
                        </p>
                        <div className="row">
                          <div className="col-sm-12 mb-1">
                            <div class="form-check">
                              <input
                                disabled={true}
                                class="form-check-input"
                                type="checkbox"
                                name="IsCopyAddress"
                                value="1"
                                id="IsCopyAddress"
                                checked={
                                  formData.IsCopyAddress == 1
                                    ? "checked"
                                    : false
                                }
                              />
                              <label
                                class="form-check-label"
                                for="IsCopyAddress"
                              >
                                Is Same as Correspondence Address?
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="">
                              <label className="form-label">Address Type</label>
                              <Select
                                isDisabled={true}
                                name="PermanentAddressType"
                                value={formData.PermanentAddressType}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                Address <span className="required">*</span>
                              </label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="PermanentAddress"
                                value={formData.PermanentAddress}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Country</label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="PermanentCountry"
                                value={formData.PermanentCountry?.label}
                              ></input>
                            </div>
                          </div>  <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">State</label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="PermanentState"
                                value={formData.PermanentState?.label}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <label className="form-label">
                              City<span className="required">*</span>
                            </label>
                            <Select
                              isDisabled={true}
                              name="PermanentCity"
                              value={formData.PermanentCity}
                            ></Select>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Zip Code</label>
                              <input
                                disabled={true}
                                type="text"
                                className="form-control"
                                name="PermanentZip"
                                value={formData.PermanentZip}
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label className="form-label">
                                Print Address
                              </label>
                              <input
                                disabled={true}
                                className="form-control"
                                type="text"
                                name="PermanentAddressPrint"
                                value={formData.PermanentAddressPrint}
                              />
                            </div>
                          </div>
                          {/* <div className="col-sm-12 me-2">
                                                            <div class="form-check mt-2">
                                                                <input class="form-check-input"

                                                                    type="checkbox"
                                                                    name="Contact"
                                                                    value="1"
                                                                    id="Contact"
                                                                    checked={formDataVerified.Contact == 1 ? 'checked' : false}
                                                                    onClick={(e) => handleChange(e, 'Contact', 0)}
                                                                />
                                                                <label class="form-check-label" for="IsCopyAddress">
                                                                    Is Verified?
                                                                </label>
                                                            </div>
                                                        </div> */}
                          <div className="col-sm-12 text-end">
                            {(formDataVerified.Contact == 0 ||
                              formDataVerified.Contact == 2) && (
                                <div className="d-flex justify-content-end">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-bottom">
                                        Accept
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      onClick={(e) =>
                                        handleChange(e, "Contact", 0, true)
                                      }
                                      className="btn btn-sm btn-success me-1"
                                    >
                                      <i className="bi bi-check2-circle"></i>
                                    </button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-bottom">
                                        Reject
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      onClick={(e) =>
                                        handleChange(e, "Contact", 0, false)
                                      }
                                      className="btn btn-sm btn-danger"
                                    >
                                      <i className="bi bi-x-circle"></i>
                                    </button>
                                  </OverlayTrigger>
                                </div>
                              )}
                            {formDataVerified.Contact == 1 && (
                              <>
                                <span className="text-success">ACCEPTED</span>
                              </>
                            )}
                            {formDataVerified.Contact == 3 && (
                              <>
                                <span className="text-danger">REJECTED</span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Qualification */}
                <div
                  className="tab-pane fade show"
                  id="Qualification"
                  role="tabpanel"
                  aria-labelledby="Qualification-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="table-responsive poc-head rounded">
                            <table
                              id="poctable_head"
                              className="table table-bordered"
                            >
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "15%" }}>
                                    Qualification Type
                                  </th>
                                  <th style={{ width: "10%" }}>Stream</th>
                                  <th style={{ width: "20%" }}>Institute</th>
                                  <th style={{ width: "5%" }}>Percentage</th>
                                  <th style={{ width: "15%" }}>
                                    Year Of Passing
                                  </th>
                                  <th style={{ width: "15%" }}>University</th>
                                  <th style={{ width: "10%" }}>Document</th>
                                  <th style={{ width: "10%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.Qualification &&
                                  formData.Qualification.map &&
                                  formData.Qualification.map((line, index) => (
                                    <tr>
                                      <td>
                                        <input
                                          disabled={true}
                                          className="form-control"
                                          name="Type"
                                          value={
                                            formData.Qualification[index].Type
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          disabled={true}
                                          className="form-control"
                                          name="Stream"
                                          value={
                                            formData.Qualification[index].Stream
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          disabled={true}
                                          className="form-control"
                                          name="Institute"
                                          value={
                                            formData.Qualification[index]
                                              .Institute
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          disabled={true}
                                          className="form-control text-center"
                                          name="Percentage"
                                          value={
                                            formData.Qualification[index]
                                              .Percentage
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line.YearOfPassing}
                                          className="form-control text-center"
                                        ></input>
                                      </td>
                                      <td>
                                        <input
                                          disabled={true}
                                          className="form-control"
                                          name="University"
                                          value={
                                            formData.Qualification[index]
                                              .University
                                          }
                                        />
                                      </td>
                                      <td className="text-center align-middle">
                                        {line.FilePath && (
                                          <a href={line.FilePath} target="_blank" rel="noopener noreferrer" title="View Document">
                                            <i className="fa fa-eye" style={{ fontSize: "18px", color: "#27568B" }}></i>
                                          </a>
                                        )}
                                      </td>
                                      <td className="text-center align-middle">
                                        {formDataVerified.Qualification[
                                          index
                                        ] != 1 && (
                                            <>
                                              {(formDataVerified.Qualification[
                                                index
                                              ] == 0 ||
                                                formDataVerified.Qualification[
                                                index
                                                ] == 2 ||
                                                !formDataVerified.Qualification[
                                                index
                                                ]) && (
                                                  <div className="d-flex justify-content-center">
                                                    <OverlayTrigger
                                                      placement="top"
                                                      overlay={
                                                        <Tooltip id="tooltip-bottom">
                                                          Accept
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <button
                                                        onClick={(e) =>
                                                          handleChange(
                                                            e,
                                                            "Qualification",
                                                            index,
                                                            true
                                                          )
                                                        }
                                                        className="btn btn-sm btn-success me-1"
                                                      >
                                                        <i className="bi bi-check2-circle"></i>
                                                      </button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                      placement="top"
                                                      overlay={
                                                        <Tooltip id="tooltip-bottom">
                                                          Reject
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <button
                                                        onClick={(e) =>
                                                          handleChange(
                                                            e,
                                                            "Qualification",
                                                            index,
                                                            false
                                                          )
                                                        }
                                                        className="btn btn-sm btn-danger"
                                                      >
                                                        <i className="bi bi-x-circle"></i>
                                                      </button>
                                                    </OverlayTrigger>
                                                  </div>
                                                )}
                                            </>
                                          )}
                                        {formDataVerified.Qualification[
                                          index
                                        ] == 1 && (
                                            <>
                                              <span className="text-success">
                                                ACCEPTED
                                              </span>
                                            </>
                                          )}
                                        {formDataVerified.Qualification[
                                          index
                                        ] == 3 && (
                                            <>
                                              <span className="text-danger">
                                                REJECTED
                                              </span>
                                            </>
                                          )}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Employment Details Tab */}
                <div
                  className="tab-pane fade show"
                  id="employment"
                  role="tabpanel"
                  aria-labelledby="employment-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="table-responsive poc-head rounded">
                          <table className="table table-bordered">
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "20%" }}>Organization Name</th>
                                <th style={{ width: "15%" }}>Position</th>
                                <th style={{ width: "15%" }}>Location</th>
                                <th style={{ width: "15%" }}>Start Date</th>
                                <th style={{ width: "15%" }}>End Date</th>
                                <th style={{ width: "20%" }}>Documents</th>
                                <th style={{ width: "10%" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employment_history &&
                                (Array.isArray(formData.employment_history) ? formData.employment_history : Object.values(formData.employment_history)).length > 0 ? (
                                (Array.isArray(formData.employment_history) ? formData.employment_history : Object.values(formData.employment_history)).map((line, index) => {
                                  if (!line.OrganizationName && !line.Position) return null;
                                  return (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        disabled={true}
                                        className="form-control"
                                        value={line.OrganizationName || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        disabled={true}
                                        className="form-control"
                                        value={line.Position || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        disabled={true}
                                        className="form-control"
                                        value={line.Location || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        disabled={true}
                                        className="form-control"
                                        value={line.StartDate || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        disabled={true}
                                        className="form-control"
                                        value={line.EndDate || ""}
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      {line.OfferLetterFilePath && (
                                        <a href={line.OfferLetterFilePath} target="_blank" rel="noopener noreferrer" title="View Offer Letter" className="mx-1">
                                          <i className="fa fa-eye" style={{ fontSize: "18px", color: "#27568B" }}></i> Offer
                                        </a>
                                      )}
                                      {line.SalarySlipFilePath && (
                                        <a href={line.SalarySlipFilePath} target="_blank" rel="noopener noreferrer" title="View Salary Slip" className="mx-1">
                                          <i className="fa fa-eye" style={{ fontSize: "18px", color: "#27568B" }}></i> Salary
                                        </a>
                                      )}
                                      {line.RelievingLetterFilePath && (
                                        <a href={line.RelievingLetterFilePath} target="_blank" rel="noopener noreferrer" title="View Relieving Letter" className="mx-1">
                                          <i className="fa fa-eye" style={{ fontSize: "18px", color: "#27568B" }}></i> Relieving
                                        </a>
                                      )}
                                    </td>
                                    <td className="text-center align-middle">
                                        {formDataVerified.employment_history && formDataVerified.employment_history[
                                          index
                                        ] != 1 && (
                                            <>
                                              {(!formDataVerified.employment_history || formDataVerified.employment_history[
                                                index
                                              ] == 0 ||
                                                formDataVerified.employment_history[
                                                index
                                                ] == 2 ||
                                                !formDataVerified.employment_history[
                                                index
                                                ]) && (
                                                  <div className="d-flex justify-content-center">
                                                    <OverlayTrigger
                                                      placement="top"
                                                      overlay={
                                                        <Tooltip id="tooltip-bottom">
                                                          Accept
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <button
                                                        onClick={(e) =>
                                                          handleChange(
                                                            e,
                                                            "employment_history",
                                                            index,
                                                            true
                                                          )
                                                        }
                                                        className="btn btn-sm btn-success me-1"
                                                      >
                                                        <i className="bi bi-check2-circle"></i>
                                                      </button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                      placement="top"
                                                      overlay={
                                                        <Tooltip id="tooltip-bottom">
                                                          Reject
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <button
                                                        onClick={(e) =>
                                                          handleChange(
                                                            e,
                                                            "employment_history",
                                                            index,
                                                            false
                                                          )
                                                        }
                                                        className="btn btn-sm btn-danger"
                                                      >
                                                        <i className="bi bi-x-circle"></i>
                                                      </button>
                                                    </OverlayTrigger>
                                                  </div>
                                                )}
                                            </>
                                          )}
                                        {formDataVerified.employment_history && formDataVerified.employment_history[
                                          index
                                        ] == 1 && (
                                            <>
                                              <span className="text-success">
                                                ACCEPTED
                                              </span>
                                            </>
                                          )}
                                        {formDataVerified.employment_history && formDataVerified.employment_history[
                                          index
                                        ] == 3 && (
                                            <>
                                              <span className="text-danger">
                                                REJECTED
                                              </span>
                                            </>
                                          )}
                                      </td>
                                  </tr>
                                )})
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">No Employment Details Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Additional Details Tab */}
                <div
                  className="tab-pane fade show"
                  id="additional"
                  role="tabpanel"
                  aria-labelledby="additional-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      {/* Left Side: Data Fields (10 columns) */}
                      <div className="col-sm-10">
                        <div className="row g-3">
                          {/* Work Experience Group */}
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="form-label text-muted small fw-bold">Total Years Exp</label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={formData.TotalYearExp || "0"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="form-label text-muted small fw-bold">Total Months Exp</label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={formData.TotalMonthExp || "0"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="form-label text-muted small fw-bold">Marital Status</label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={formData.MaritalStatusName || "N/A"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="form-label text-muted small fw-bold">Blood Group</label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={formData.BloodGroupName || "N/A"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="form-label text-muted small fw-bold">PF Nominee Name</label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={formData.PFNomineeName || "N/A"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="form-label text-muted small fw-bold">PF Nominee Relation</label>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={formData.PFNomineeRelation || "N/A"}
                              />
                            </div>
                          </div>

                          {/* Family Details - Conditional */}
                          {formData.MaritalStatus_021 === 140 && (
                            <>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <label className="form-label text-muted small fw-bold">Spouse Name</label>
                                  <input
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                    value={formData.SpouseName || "—"}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <label className="form-label text-muted small fw-bold">Spouse DOB</label>
                                  <input
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                    value={formData.SpouseDOB || "—"}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <label className="form-label text-muted small fw-bold">Child 1 Name</label>
                                  <input
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                    value={formData.Child1Name || "—"}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <label className="form-label text-muted small fw-bold">Child 1 DOB</label>
                                  <input
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                    value={formData.Child1DOB || "—"}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <label className="form-label text-muted small fw-bold">Child 2 Name</label>
                                  <input
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                    value={formData.Child2Name || "—"}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Right Side: Verification Actions (2 columns) */}
                          <div className="col-sm-2 mt-4 text-end border-start">
                            <div className="mb-3">
                              {/* 
                                The condition below checks if the status is:
                                0 (Pending), 2 (Edited/Re-verify), or undefined (Initial Load)
                              */}
                              {(formDataVerified.Additional === 0 || 
                                formDataVerified.Additional === 2 || 
                                formDataVerified.Additional === undefined) && (
                                <div className="d-flex justify-content-end">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-accept">Accept</Tooltip>}
                                  >
                                    <button
                                      onClick={(e) => handleChange(e, "Additional", 0, true)}
                                      className="btn btn-sm btn-success me-1"
                                    >
                                      <i className="bi bi-check2-circle"></i>
                                    </button>
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-reject">Reject</Tooltip>}
                                  >
                                    <button
                                      onClick={(e) => handleChange(e, "Additional", 0, false)}
                                      className="btn btn-sm btn-danger"
                                    >
                                      <i className="bi bi-x-circle"></i>
                                    </button>
                                  </OverlayTrigger>
                                </div>
                              )}

                              {/* Show "ACCEPTED" text if status is 1 */}
                              {formDataVerified.Additional === 1 && (
                                <span className="text-success fw-bold small">
                                  <i className="bi bi-shield-check me-1"></i>ACCEPTED
                                </span>
                              )}

                              {/* Show "REJECTED" text if status is 3 */}
                              {formDataVerified.Additional === 3 && (
                                <span className="text-danger fw-bold small">
                                  <i className="bi bi-shield-x me-1"></i>REJECTED
                                </span>
                              )}
                            </div>
                          </div>
                    </div>
                  </div>
                </div>
                {/* Bank Details Tab */}
                <div
                  className="tab-pane fade show"
                  id="Bank"
                  role="tabpanel"
                  aria-labelledby="Bank-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="table-responsive poc-head rounded">
                          <table className="table table-bordered">
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "15%" }}>Pay To</th>
                                <th style={{ width: "15%" }}>Bank</th>
                                <th style={{ width: "15%" }}>Branch</th>
                                <th style={{ width: "15%" }}>Account No.</th>
                                <th style={{ width: "15%" }}>IFSC Code</th>
                                <th style={{ width: "5%", textAlign: "center" }}>Default</th>
                                <th style={{ width: "10%" }}>Verification Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employeebank && formData.employeebank.length > 0 ? (
                                formData.employeebank.map((line, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="text"
                                        disabled={true}
                                        className="form-control"
                                        value={line.PayTo || `${formData.FirstName || ""} ${formData.LastName || ""}`.trim()}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        disabled={true}
                                        className="form-control"
                                        value={line.BankName || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        disabled={true}
                                        className="form-control"
                                        value={line.Branch || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        disabled={true}
                                        className="form-control"
                                        value={line.AccountNo || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        disabled={true}
                                        className="form-control"
                                        value={line.IFSCCode || ""}
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <input
                                        type="checkbox"
                                        disabled={true}
                                        checked={line.DefaultBank == 1}
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      {/* The line you want */}
                                      {formDataVerified.BankDetails?.[index] == 1 && (
                                        <span className="text-success font-weight-bold">ACCEPTED</span>
                                      )}

                                      {/* Status 3: Rejected */}
                                      {formDataVerified.BankDetails?.[index] == 3 && (
                                        <span className="text-danger font-weight-bold">REJECTED</span>
                                      )}

                                      {/* Show buttons only if NOT accepted and NOT rejected */}
                                      {formDataVerified.BankDetails?.[index] != 1 && formDataVerified.BankDetails?.[index] != 3 && (
                                        <>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="acc-bank">Accept</Tooltip>}
                                          >
                                            <button
                                              onClick={(e) => handleChange(e, "BankDetails", index, true)} // Send true for Accepted
                                              className="btn btn-sm btn-success me-1"
                                            >
                                              <i className="bi bi-check2-circle"></i>
                                            </button>
                                          </OverlayTrigger>

                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="rej-bank">Reject</Tooltip>}
                                          >
                                            <button
                                              onClick={(e) => handleChange(e, "BankDetails", index, false)} // Send false for Rejected
                                              className="btn btn-sm btn-danger"
                                            >
                                              <i className="bi bi-x-circle"></i>
                                            </button>
                                          </OverlayTrigger>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">No bank details available</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Employee Attachment */}
                <div
                  className="tab-pane fade show"
                  id="attachment"
                  role="tabpanel"
                  aria-labelledby="attachment-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="table-responsive poc-head rounded">
                            <table
                              id="poctable_head"
                              className="table table-bordered"
                            >
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "40%" }}>File Link</th>
                                  <th style={{ width: "20%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.employeeAttachments &&
                                  formData.employeeAttachments.map &&
                                  formData.employeeAttachments.map(
                                    (line, index) => (
                                      <tr>
                                        <td>
                                          <a href={line.FilePath} target="_blank">
                                            {line.FileName}
                                          </a>
                                        </td>

                                        <td className="text-center align-middle">
                                          {(formDataVerified.Files[index] ===
                                            0 ||
                                            formDataVerified.Files[index] ===
                                            2) && (
                                              <div className="d-flex justify-content-center">
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id="tooltip-bottom">
                                                      Accept
                                                    </Tooltip>
                                                  }
                                                >
                                                  <button
                                                    onClick={(e) =>
                                                      handleChange(
                                                        e,
                                                        "Files",
                                                        index,
                                                        true
                                                      )
                                                    }
                                                    className="btn btn-sm btn-success me-1"
                                                  >
                                                    <i className="bi bi-check2-circle"></i>
                                                  </button>
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id="tooltip-bottom">
                                                      Reject
                                                    </Tooltip>
                                                  }
                                                >
                                                  <button
                                                    onClick={(e) =>
                                                      handleChange(
                                                        e,
                                                        "Files",
                                                        index,
                                                        false
                                                      )
                                                    }
                                                    className="btn btn-sm btn-danger"
                                                  >
                                                    <i className="bi bi-x-circle"></i>
                                                  </button>
                                                </OverlayTrigger>
                                              </div>
                                            )}
                                          {formDataVerified.Files[index] ===
                                            1 && (
                                              <>
                                                <span className="text-success">
                                                  ACCEPTED
                                                </span>
                                              </>
                                            )}
                                          {formDataVerified.Files[index] ===
                                            3 && (
                                              <>
                                                <span className="text-danger">
                                                  REJECTED
                                                </span>
                                              </>
                                            )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Employee Identities */}
                <div
                  className="tab-pane fade show"
                  id="identities"
                  role="tabpanel"
                  aria-labelledby="identities-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="table-responsive poc-head rounded">
                            <table
                              id="poctable_head"
                              className="table table-bordered"
                            >
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "15%" }}>
                                    Identity Type
                                  </th>
                                  <th style={{ width: "25%" }}>
                                    Name On Identity
                                  </th>
                                  <th style={{ width: "15%" }}>Identity No.</th>
                                  <th style={{ width: "15%" }}>
                                    Issuing Country
                                  </th>
                                  <th style={{ width: "10%" }}>Issue Date</th>
                                  <th style={{ width: "10%" }}>Expiry Date</th>
                                  <th style={{ width: "10%" }}>Document</th>
                                  <th style={{ width: "10%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.Identities &&
                                  formData.Identities.map &&
                                  formData.Identities.map((line, index) => (
                                    <tr>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line.Type?.label}
                                          className="form-control"
                                        ></input>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line.Name}
                                          className="form-control"
                                        ></input>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line.Number}
                                          className="form-control"
                                        ></input>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line?.Country?.label}
                                          className="form-control"
                                        ></input>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line.issueDate}
                                          className="form-control"
                                        ></input>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          disabled={true}
                                          value={line.expiryDate}
                                          className="form-control"
                                        ></input>
                                      </td>
                                      <td className="text-center align-middle">
                                        {line.FilePath && (
                                          <a href={line.FilePath} target="_blank" rel="noopener noreferrer" title="View Document">
                                            <i className="fa fa-eye" style={{ fontSize: "18px", color: "#27568B" }}></i>
                                          </a>
                                        )}
                                      </td>
                                      <td className="text-center align-middle">
                                        <>
                                          {(formDataVerified.Identities[
                                            index
                                          ] == 0 ||
                                            formDataVerified.Identities[
                                            index
                                            ] == 2) && (
                                              <div className="d-flex justify-content-center">
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id="tooltip-bottom">
                                                      Accept
                                                    </Tooltip>
                                                  }
                                                >
                                                  <button
                                                    onClick={(e) =>
                                                      handleChange(
                                                        e,
                                                        "Identities",
                                                        index,
                                                        true
                                                      )
                                                    }
                                                    className="btn btn-sm btn-success me-1"
                                                  >
                                                    <i className="bi bi-check2-circle"></i>
                                                  </button>
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id="tooltip-bottom">
                                                      Reject
                                                    </Tooltip>
                                                  }
                                                >
                                                  <button
                                                    onClick={(e) =>
                                                      handleChange(
                                                        e,
                                                        "Identities",
                                                        index,
                                                        false
                                                      )
                                                    }
                                                    className="btn btn-sm btn-danger"
                                                  >
                                                    <i className="bi bi-x-circle"></i>
                                                  </button>
                                                </OverlayTrigger>
                                              </div>
                                            )}
                                        </>
                                        {formDataVerified.Identities[index] ==
                                          1 && (
                                            <>
                                              <span className="text-success">
                                                ACCEPTED
                                              </span>
                                            </>
                                          )}
                                        {formDataVerified.Identities[index] ==
                                          3 && (
                                            <>
                                              <span className="text-danger">
                                                REJECTED
                                              </span>
                                            </>
                                          )}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid d-flex justify-content-end mt-2">
                <div>
                  <button type="reset" className="cancel-btn me-2">
                    Cancel
                  </button>

                  <button
                    onClick={(e) => handleSubmit(e)}
                    disabled={submitted ? true : false}
                    type=""
                    className="custom-btn"
                  >
                    {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
};

export default AddEmployee;
